import $ from "jquery";

const pageLoaderSelector = "#catifa-page-loader";

const $pageLoader = $(pageLoaderSelector);

export const showPageLoader = () => {
  $pageLoader.removeClass("-z-10").addClass("z-[100]").show();
};

export const hidePageLoader = () => {
  $pageLoader.removeClass("z-[100]").addClass("-z-10").hide();
};
